import { InfoOutlined, Link } from "@clockwise/design-system/icons";
import { ExpandableCard } from "@clockwise/web-commons/src/ui/expandable-card";
import { Tooltip } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { useLocalStorage } from "usehooks-ts";
import { IReduxState } from "../../state/reducers/root.reducer";
import { SchedulingLinksCompact } from "../scheduling-link/SchedulingLinksCompact";

const tooltipText =
  "Share your availability instantly - Clockwise will find the best time to meet, based on your Focus Time and scheduling needs.";

export const SchedulingLinksSidebar = () => {
  const [prevExpanded, setExpandedLocalStorage] = useLocalStorage(
    "cw-scheduling-links-sidebar-expanded",
    false,
  );

  const openShareLinkModal = useSelector(
    (state: IReduxState) => state.webExtension.openShareLinkModal,
  );

  return (
    <div className="cw-relative">
      <ExpandableCard
        defaultExpanded={prevExpanded || openShareLinkModal}
        onExpand={() => {
          setExpandedLocalStorage(true);
        }}
        onCollapse={() => {
          setExpandedLocalStorage(false);
        }}
        expandedHeight={400}
        topContent={
          <div className="cw-heading-sm cw-flex cw-flex-row cw-items-center" cw-id="links-section">
            <Link className="cw-w-[20px] cw-mr-[14px] cw-text-brand" />
            <span className="cw-mr-2">Scheduling Links</span>
            <Tooltip
              placement="bottom"
              title={tooltipText}
              classes={{ popper: "cw-max-w-[168px]" }}
            >
              <InfoOutlined className="cw-h-[14px] cw-w-[14px] cw-text-subtle" />
            </Tooltip>
          </div>
        }
        bottomContent={
          <div className="cw-mb-4">
            <SchedulingLinksCompact surface="sidebar" />
          </div>
        }
      />
    </div>
  );
};
